module.exports = __webpack_public_path__ + "img/dash1-dark.69568d1f.png";